<!--中间主界面组件-->
<template>
  <div :class="`home ${isMini ? 'mini' : ''}`">
    <el-container class="el-container">
      <!--侧边栏-->
      <el-aside
        class="el-aside"
        v-if="
          this.$store.state.user !== null &&
            this.$store.state.role !== null &&
              this.$store.state.role.indexOf(this.$VAR.ordinaryRole) === -1
        "
      >
        <Aside></Aside>
      </el-aside>
      <!--导航栏-->
      <el-container class="el-container">
        <el-header class="el-header">
          <Header></Header>
        </el-header>
        <!--主面板-->
        <el-main class="el-main">
          <router-view></router-view>
        </el-main>
        <!--底部-->
        <el-footer
          class="el-footer"
          v-if="
            this.$store.state.role !== null &&
              this.$store.state.role.indexOf(this.$VAR.ordinaryRole) === -1
          "
        >
          <div class="footer">
            <span
              >Copyright&nbsp;©&nbsp;&nbsp;{{
                new Date().getFullYear()
              }}&nbsp;&nbsp; &nbsp;</span
            >
          </div>
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Aside from "./Aside";
import Header from "./Header";
import ProductList from "../product/ProductList";
import ProductAdd from "../product/ProductAdd";

export default {
  name: "Home",
  components: { Aside, Header, ProductList, ProductAdd },
  data() {
    return {
      isMini: false,
    }
  },
  mounted() {
    this.isMini = this.$tools.checkWidth();
  },
};
</script>

<style>
.home {
  height: 100%;
}

.home .el-container {
  height: 100%;
}

.home .el-header {
  padding: 0;
  background-color: #fff;
  color: #333;
  text-align: center;
  border-bottom: 1px solid #c1c1c1;
}
.home .el-footer {
  padding: 0;
  color: #333;
  height: 50px !important;
  background: #ffffff;
  line-height: 50px;
}

.home .el-aside {
  width: 180px !important;
  background-color: #d3dce6;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.home .el-main {
  background-color: #fff;
  border-top: 1px solid #c1c1c1;
  color: #333;
  text-align: center;
  padding: 0;
  margin: 0;
}

.home .el-main::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0; /*高宽分别对应横竖滚动条的尺寸*/
}

.home .footer {
  width: auto;
  height: 100%;
  line-height: 50px;
  font-size: 10px;
  user-select: none;
}
/* 小屏模式-样式适配 */
.home.mini {
  min-width: 300px !important;
  overflow-x: auto !important;
}
.home.mini .el-header .header > .el-breadcrumb {
  padding: 0 16px;
}
/* 搜索 */
.home.mini .mall-main .mall-nav ul > li {
  margin: 0 10px !important;
}
.home.mini .mall-main .mall-nav ul > li:first-child {
  width: calc(100% - 20px) !important;
  text-align: center;
  height: 40px;
  line-height: 40px;
  padding: 0;
}
.home.mini .mall-main .mall-nav ul > li:first-child a {
  position: relative !important;
}
.home.mini .mall-main .mall-nav ul > li:nth-child(2) {
  float: right !important;
  width: calc(100% - 20px) !important;
}
.home.mini .mall-main .mall-nav ul > li:nth-child(2) .el-input-group__append {
  padding: 0 3px 0 6px !important;
}
.home.mini .mall-main .mall-nav ul > li:nth-child(3),
.home.mini .mall-main .mall-nav ul > li:nth-child(4) {
  display: none !important;
  width: calc(50% - 20px) !important;
}
/* 轮播图 */
.home.mini .mall-main .slideshow {
  width: 100%;
  min-width: 200px;
  height: 200px;
}
.home.mini .mall-main .slideshow .el-carousel__container {
  height: 200px !important;
}
/* 新品专区 */
.home.mini .mall-main .new-product {
  min-width: 100%;
  min-height: 100px !important;
}    
.home.mini .mall-main .new-product .box-hd h2 {
  width: 100%;
  text-align: center;
}
.home.mini .mall-main .new-product .new-sale {
  display: none;
}
.home.mini .mall-main .new-product .new-product-info {
  width: 100%;
  height: 220px;
  margin: 0 !important;
}
.home.mini .mall-main .new-product .new-product-info .sale-list li {
  width: 120px !important;
  padding-top: 5px !important;
}
.home.mini .mall-main .new-product .new-product-info .sale-list li .el-image.img {
  width: 110px !important;
  height: 110px !important;
  margin-bottom: 5px !important;
}
.home.mini .mall-main .new-product .new-product-info .sale-list li .title {
  margin: 5px !important;
}
.home.mini .mall-main .new-product .new-product-info .sale-list li .desc {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  height: 36px;
  line-height: 18px;
  white-space: break-spaces;
  margin: 5px !important;
}
.home.mini .mall-main .product {
  width: 100%;
  min-width: 200px;
}
.home.mini .mall-main .product .product-info {
  height: auto !important;
  margin-bottom: 0 !important;
}
  .home.mini .mall-main .product .product-info > .el-image {
  width: 100% !important;
  min-width: 100% !important;
  margin: 10px 0 0 0 !important;
}
.home.mini .mall-main .product .product-info > .box-hd h2 {
 margin-left: 10px;
}
.home.mini .mall-main .product .product-info > .box-hd .more {
  right: 10px;
}
.home.mini .mall-main .product .product-info > .product-type-promo {
  display: none;
}
.home.mini .mall-main .product .product-info > .product-item {
  width: calc(100% - 20px) !important;
  height: auto !important;
  padding: 0 10px;
}
.home.mini .mall-main .product .product-info > .product-item li {
  width: calc((100% - 20px) / 3) !important;
  height: 200px !important;
  padding: 10px 0 !important;
  margin: 0 0 10px 0 !important;
  border-radius: 6px !important;
}
/* :nth-of-type(3n+0) */
.home.mini .mall-main .product .product-info > .product-item li:nth-child(3n + 2) {
  margin: 0 10px !important;
}
.home.mini .mall-main .product .product-info > .product-item li .el-image {
  width: 110px !important;
  height: 110px !important;
  margin-bottom: 0 !important;
}
.home.mini .mall-main .product .product-info > .product-item li .title {
  margin: 0 5px !important;
}
.home.mini .mall-main .product .product-info > .product-item li .desc {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  height: 36px;
  line-height: 18px;
  white-space: break-spaces;
  margin: 3px 5px 0 5px !important;
}
.home.mini .mall-main .product .product-info > .product-item li .price {
  margin: 0 !important;
}
/* 商品详情 */
.home.mini .mall-purchase.mall-main .product-box .nav-bar {
  height: 60px;
}
.home.mini .mall-purchase.mall-main .product-box .nav-bar .container {
  width: calc(100% - 10px);
  min-width: 100px;
  margin: 0 10px;
  display: flex;
  align-items: center;
  justify-content: start;
  height: 100%;
}
.home.mini .mall-purchase.mall-main .product-box .nav-bar .container .el-image.logo {
  width: 50px !important;
  height: 50px !important;
  margin: 0 10px 0 0 !important;
  border-radius: 10px;
}
.home.mini .mall-purchase.mall-main .product-box .nav-bar .container a.el-link {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}
.home.mini .mall-purchase.mall-main .product-box .nav-bar .container .item-title {
  position: relative !important;
  top: unset !important;
  margin: 0 !important;
  font-size: 16px !important;
}
.home.mini .mall-purchase.mall-main .product-info {
  width: 100%;
  min-width: 100px;
  min-height: 100px;
  margin: 16px auto;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content {
  padding: 0 !important;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .img {
  width: calc(100% - 32px);
  height: auto;
  min-width: 100px;
  min-height: 160px;
  padding: 16px;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .img .el-image {
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  border-radius: 10px;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .product-con {
  width: calc(100% - 32px);
  min-width: 100px;
  min-height: 100px;
  margin: 0 !important;
  padding: 0 16px !important;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .product-con .price-info {
  padding: 10px 0 !important;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .product-con .line {
  margin: 6px 0 0 0 !important;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .product-con .address-box {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .product-con .address-box i {
  width: 30px;
  padding: 3px 0 0 0 !important;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .product-con .address-box .address-con {
  width: calc(100% - 76px);
  font-size: 18px;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .product-con .address-box .address-alter {
  float: right;
  width: 30px;
  margin: 3px 0 0 12px !important;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .product-con .select-amount {
  width: calc(100% - 40px);
  margin: 0 20px;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .product-con .select-amount > div {
  display: block;
  float: left;
  width: 50%;
  margin-top: 20px !important;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .product-con .select-amount > .el-input-number {
  margin: 20px 0 0 0 !important;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .product-con .selected-list {
  padding: 0 !important;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .product-con .selected-list > span {
  display: none;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .product-con .selected-list .total-price {
  width: calc(100% - 40px);
  margin: 0 20px;
  padding: 10px 0 0 0 !important;
  text-align: right;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .product-con .selected-list .total-price span {
  display: block;
  float: left;
  width: 50%;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .product-con .selected-list .total-price span:first-child {
  text-align: left;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .product-con .selected-list div > button {
  float: left;
  width: calc(50% - 40px);
  margin: 20px !important;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content h3 {
  margin: 0 16px;
  padding-bottom: 20px;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .detail-list {
  width: calc(100% - 32px);
  margin: 0 16px !important;
  padding-bottom: 20px;
}
.home.mini .mall-purchase.mall-main .product-info .product-info-content .detail-list .detail-img {
  display: inline-block;
  width: 100%;
  height: auto;
  margin: 0 !important;
  padding: 0 !important;
  font-size: 0;
}
/* 底部 */
.home.mini .mall-footer .container {
  width: 100%;
  height: 100%;
}
.home.mini .mall-footer .footer-service {
  min-width: 200px !important;
  padding: 16px 0 !important;
  height: auto;
}
.home.mini .mall-footer .footer-service .list-service li {
  width: 50% !important;
  height: 30px !important;
  border-left: none !important;
}
.home.mini .mall-footer .footer-copyright {
  display: block;
  background: #fff;
}
.home.mini .mall-footer .footer-copyright .copyright span {
  display: block;
  width: 100%;
  font-size: 14px;
}
.home.mini .mall-footer .footer-copyright .copyright span+span {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/container/Home.vue